import React, { useRef } from "react";
import styled from "styled-components";
import PerfectScrollbar from "perfect-scrollbar";
import { node, bool } from "prop-types";

import { useEffect } from "react";

import "perfect-scrollbar/css/perfect-scrollbar.css";

const ContentContainer = styled.div`
  -ms-overflow-style: none;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  overflow: hidden;
  padding-bottom: ${({ hideScrollbar }) =>
    hideScrollbar ? "0 !important" : "1.25rem"};
  position: relative;
  scrollbar-width: none;
  white-space: nowrap;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  .ps__rail-x {
    background-color: #f5f5f5;
    border-radius: 10px;
    display: ${({ hideScrollbar }) => (hideScrollbar ? "none" : "block")};
    height: 15px;
    opacity: 1;
    width: 100%;
  }

  .ps__thumb-x {
    background-image: linear-gradient(
      47deg,
      rgba(65, 65, 68, 1) 16%,
      rgba(54, 54, 54, 1) 47%,
      rgba(36, 37, 30, 1) 97%
    );

    border-radius: 10px;
    bottom: 0px;
    display: block;
    height: 15px !important;
  }
`;

const ScrollableContainer = ({
  children,
  isDisabled = false,
  isVisible = true,
  ...props
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (!containerRef.current || !isVisible) {
      return;
    }

    const initializePerfectScrollBar = () => {
      const perfectScrollInstance = new PerfectScrollbar(containerRef.current);
      if (
        (isDisabled || perfectScrollInstance.scrollbarXWidth === 0) &&
        children.length <= 1
      ) {
        perfectScrollInstance.destroy();
      }
      return perfectScrollInstance;
    };

    let perfectScroll = initializePerfectScrollBar();

    // perfect-scrollbar is not initialized correctly on elements with display: "none" styling
    // the solution is to initialize perfect-scrollbar only if isVisible === true
    // but if perfectScroll.contentWidth is still 0 - then wait for a few moments and initialize it again
    let initializeTimeout = null;

    if (perfectScroll.contentWidth === 0) {
      initializeTimeout = setTimeout(() => {
        perfectScroll.destroy();
        perfectScroll = initializePerfectScrollBar();
      }, 50);
    }

    return () => {
      clearTimeout(initializeTimeout);
      perfectScroll.destroy();
    };
  }, [containerRef.current, isDisabled, children.length, isVisible]);

  return (
    <ContentContainer
      ref={containerRef}
      {...props}
      hideScrollbar={children.filter(Boolean).length < 2}
    >
      {children}
    </ContentContainer>
  );
};

ScrollableContainer.propTypes = {
  children: node.isRequired,
  isDisabled: bool,
  isVisible: bool,
};

export default ScrollableContainer;
